<script>
    import { section } from "../store/section.js";
    import { token } from "../store/token.js";
    import { active_workspace } from "../store/workspace.js";

    import { fade } from "svelte/transition";

    import { fetch_workspace_sso_config } from "../api/request.js";

    import HeadingContent from "./component/HeadingContent.svelte";

    const set_section = (selected_section) => {
        section.set(selected_section);
    };

    let message;
    let sso_config;
    let company_domain;
    let okta_company_domain;
    let client_id;
    let client_secret;

    $: {
        if (message) {
            console.log(message);
        }
        setTimeout(() => {
            message = null;
        }, 5000);
    }

    const fetch_sso_config = async () => {
        const data = await fetch_workspace_sso_config(
            $active_workspace.string_id,
            $token,
        );

        sso_config = data;

        if (sso_config.configured == false) {
            
        } else {
            company_domain = sso_config.domain;
            okta_company_domain = sso_config.base_uri;
            client_id = sso_config.client_id;
            client_secret = sso_config.client_secret;
        }

        return data;
    };

    const update_sso_config = () => {
        submitted_state = true;
        fetch(`${process.env.API_ROOT}/sso/workspace/config/update`, {
            method: "POST",
            mode: "cors",
            headers: {
                Authorization: "Bearer " + $token,
                "control-workspace": $active_workspace.string_id,
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                sso_domain: company_domain,
                sso_base_uri: okta_company_domain,
                sso_client_id: client_id,
                sso_client_secret: client_secret,
            }),
        })
            .then((response) => {
                fetch_sso_config();
                submitted_state = false;
                message = `SSO configuration saved successfully.`;
            })
            .catch(console.log);
    };

    var submitted_state = false;
</script>

<div class="settings-holder settings-active">
    <!-- Settings Connections Overview (First Level) (the items of the menu of Security)-->
    <div class="settings-holder-content content-active">
        <HeadingContent
            title="Configure SSO for {$active_workspace.title}"
            back_button_enabled={true}
            back_button_click_action={() => {
                set_section("account/workspaces/overview");
            }}
        />
        <!--
        <div class="settings-heading">
            <div
                class="heading-block"
                on:click={() => {
                    set_section("account/workspaces/overview");
                }}
            >
                <a class="nav-opener" href="#"
                    ><i class="icon icon-navigation" /></a
                ><a class="nav-back" href="#">
                    <div class="ico-holder">
                        <i class="icon icon-chevron-left" />
                    </div>
                    <div class="title-holder">
                        <strong class="settings-title"
                            >Configure SSO for {$active_workspace.title}</strong
                        >
                    </div></a
                >
            </div>
        </div>
        -->
        {#await fetch_sso_config()}
            <div class="settings-content">
                <div class="settings-content-holder">
                    Loading SSO configuration
                </div>
            </div>
        {:then __info}
            <div class="settings-content">
                <div class="settings-content-holder">
                    {#if sso_config.configured == true}
                        <div class="card-personal card">
                            <div class="card-body">
                                <div class="card-form-block">
                                    <h2 style="margin-bottom:10px">
                                        SSO is configured <img
                                            alt="SSO is configured"
                                            src="account/images/icon-check.png"
                                            style="max-height:24px;margin-top: 8px;"
                                        />
                                    </h2>
                                    <div
                                        class="form-group"
                                        style="margin-bottom:0px"
                                    >
                                        Your company users can log in using <a
                                            target="_blank"
                                            href="https://{sso_config.domain}"
                                            >{sso_config.domain}</a
                                        >
                                        company email on the
                                        <a
                                            target="_blank"
                                            href="https://trn-ctrl-api-staging-w2.herokuapp.com/sso"
                                            >Control SSO login page</a
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    {:else}
                        <div class="card-personal card">
                            <div class="card-body">
                                <div class="card-form-block">
                                    <h2 style="margin-bottom:10px">
                                        Configure SSO
                                    </h2>
                                    <div
                                        class="form-group"
                                        style="margin-bottom:0px"
                                    >
                                        Configure your company’s SSO using the
                                        form below.
                                    </div>
                                </div>
                            </div>
                        </div>
                    {/if}
                    <div class="card-personal card">
                        <div class="card-body">
                            <div class="card-form-block">
                                <h5>Edit SSO configuration</h5>
                                <div
                                    class="card-block"
                                    style="margin-bottom: 0px;padding-bottom:10px"
                                >
                                    <h2
                                        class="h6 card-title"
                                        style="margin-bottom: 4px"
                                    >
                                        Company Domain
                                    </h2>
                                    <p style="margin-bottom: 0px">
                                        Enter the domain your company's users
                                        are utilising to log in to services via
                                        Okta, without https:// protocol
                                        (example: your-company.com)
                                    </p>
                                </div>
                                <div class="form-group">
                                    <span class="input-with-label"
                                        ><label
                                            for="display-name-personal"
                                            style="position:absolute;padding-top:14px;padding-left:16px"
                                            >https://</label
                                        >
                                        <input
                                            id="display-name-personal"
                                            type="text"
                                            placeholder="example-company.com"
                                            data-required="true"
                                            style="padding-left:65px"
                                            bind:value={company_domain}
                                        />
                                    </span>
                                    <!--<div class="info">
                                        Enter the domain your company's users
                                        are utilising to log in to services via
                                        Okta, without https:// protocol
                                        (example: your-company.com)
                                    </div>-->
                                    <div class="error">Enter a valid Name</div>
                                </div>

                                <div
                                    class="card-block"
                                    style="margin-bottom: 0px;padding-bottom:10px"
                                >
                                    <h2
                                        class="h6 card-title"
                                        style="margin-bottom: 4px"
                                    >
                                        Okta Domain
                                    </h2>
                                    <p style="margin-bottom: 0px">
                                        Enter your Okta domain, found in the top
                                        right corner of Okta Admin Panel
                                        (example: your-company.okta.com, <a
                                            target="_blank"
                                            href="account/images/okta_company_domain_guide.png"
                                            >see screenshot</a
                                        >)
                                    </p>
                                </div>
                                <div class="form-group">
                                    <input
                                        id="full-name-personal"
                                        type="text"
                                        placeholder="example-company.okta.com"
                                        data-required="true"
                                        bind:value={okta_company_domain}
                                    />
                                    <!--<div class="info">
                                        Okta domain, found in the top right
                                        corner of Okta Admin Panel (example:
                                        your-company.okta.com, <a
                                            target="_blank"
                                            href="account/images/okta_company_domain_guide.png"
                                            >see screenshot</a
                                        >)
                                    </div>-->
                                    <div class="error">Enter a valid Name</div>
                                </div>

                                <div
                                    class="card-block"
                                    style="margin-bottom: 0px;padding-bottom:10px"
                                >
                                    <h2
                                        class="h6 card-title"
                                        style="margin-bottom: 4px"
                                    >
                                        Client ID
                                    </h2>
                                    <p style="margin-bottom: 0px">
                                        Enter the Client ID for your Control
                                        Okta App Integration (<a
                                            target="_blank"
                                            href="account/images/okta_app_integration_client_id_secret.png"
                                            >see screenshot</a
                                        >)
                                    </p>
                                </div>
                                <div class="form-group">
                                    <input
                                        type="text"
                                        placeholder="Client ID"
                                        data-required="true"
                                        bind:value={client_id}
                                    />
                                    <!--<div class="info">
                                        Client ID for your Control Okta App
                                        Integration (<a
                                            target="_blank"
                                            href="account/images/okta_app_integration_client_id_secret.png"
                                            >see screenshot</a
                                        >)
                                    </div>-->
                                    <div class="error">Enter a valid Email</div>
                                </div>

                                <div
                                    class="card-block"
                                    style="margin-bottom: 0px;padding-bottom:10px"
                                >
                                    <h2
                                        class="h6 card-title"
                                        style="margin-bottom: 4px"
                                    >
                                        Client Secret
                                    </h2>
                                    <p style="margin-bottom: 0px">
                                        Enter the Client Secret for your Control
                                        Okta App Integration (<a
                                            target="_blank"
                                            href="account/images/okta_app_integration_client_id_secret.png"
                                            >see screenshot</a
                                        >)
                                    </p>
                                </div>
                                <div class="form-group">
                                    <input
                                        id="occupation-personal"
                                        type="password"
                                        placeholder="Client Secret"
                                        data-required="true"
                                        bind:value={client_secret}
                                    />
                                    <!--<div class="info">
                                        Client Secret for your Control Okta App
                                        Integration (<a
                                            target="_blank"
                                            href="account/images/okta_app_integration_client_id_secret.png"
                                            >see screenshot</a
                                        >)
                                    </div>-->
                                    <div class="error">
                                        Enter a valid Occupation
                                    </div>
                                </div>

                                <div class="df-row df-aic df-md-jce gx-1">
                                    {#if message}
                                        <div
                                            class="col-md-auto"
                                            style="padding-top:14px"
                                            in:fade
                                            out:fade
                                        >
                                            <span style="margin-top:10px">
                                                {message}
                                            </span>
                                        </div>
                                    {/if}
                                    <div class="col-md-auto">
                                        <div
                                            class="button-holder text-md-right"
                                        >
                                            {#if submitted_state}
                                                <span
                                                    class="btn btn-primary"
                                                    style="cursor:pointer"
                                                    ><img
                                                        src="images/spinner.svg"
                                                        alt="vollume"
                                                        width="20"
                                                        height="20"
                                                    /> Saving</span
                                                >
                                            {:else if sso_config.configured == true}
                                                <span
                                                    class="btn btn-primary"
                                                    style="cursor:pointer"
                                                    on:click={() => {
                                                        update_sso_config();
                                                    }}>Update</span
                                                >
                                            {:else}
                                                <span
                                                    class="btn btn-primary"
                                                    style="cursor:pointer"
                                                    on:click={() => {
                                                        update_sso_config();
                                                    }}>Save</span
                                                >
                                            {/if}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        {:catch error}
            Failed to load SSO configuration
        {/await}
    </div>
</div>
